export const NextFollowUpDisplayMap = new Map<string, string>([
  ["today", "Today"],
  ["tomorrow", "Tomorrow"],
  ["past_due", "Past Due"],
  ["upcoming", "Upcoming"],
]);
